import React, { useState } from "react";
import { Modal, ModalBody, ModalFooter } from "react-bootstrap";
import logo from "../../assets/images/logo/app-logo.svg";
import Button from "../../components/global/button/Button";
import { toast } from "react-toastify";
import moment from "moment";

export default function BuyPackageModal(props) {
  const [preDefinedPackageId, setPreDefinedPackageId] = useState();
  const [purchaseDate, setPurchaseDate] = useState(
    moment(props?.purchaseDate).format("YYYY-MM-DD")
  );

  function handleSubmit() {
    const selectedPackage = props?.preDefinedPackageList.find(
      (packageObj) => packageObj.id === preDefinedPackageId
    );

    if (!purchaseDate) {
      toast.error("Please select a package start date");
      return;
    }

    const selectedPackageWithDate = {
      ...selectedPackage,
      purchaseDate: Date.parse(purchaseDate),
    };

    let isAlreadyPresent = false;
    let isBoughtInSameInvoice = false;
    if (props.validPackageList && props.validPackageList.length > 0) {
      isAlreadyPresent = props.validPackageList.find(
        (item) =>
          item.name.includes(selectedPackage.name) &&
          (item.remainingSessions > 0 || item.remainingSessions === undefined)
      );
    }  
    
    
    if (
      props?.appointmentId === null &&
      props?.predefinedPackagesList?.length > 0
    ) {

  
      isBoughtInSameInvoice = props?.predefinedPackagesList.find(
        (item) =>
          item.name.includes(selectedPackage.name) &&
          (item.remainingSessions > 0 || item.remainingSessions === undefined)
      );
    }

   

    if (isAlreadyPresent || isBoughtInSameInvoice) {
      toast.error(
        "You cannot purchase this pack again, as you have already bought it"
      );
    } else {
      props.updateSubtotalTotalForPackage(selectedPackageWithDate);
      setPreDefinedPackageId();
      setPurchaseDate(moment(props?.purchaseDate).format("YYYY-MM-DD"));
      props.setNewPackList([...props.newPackList, selectedPackageWithDate]);
      props.onHide();
      return;
    }

    if (
      (!props.validPackageList || props.validPackageList.length === 0) &&
      props?.appointmentId !== null
    ) {
      props.updateSubtotalTotalForPackage(selectedPackageWithDate);
      setPreDefinedPackageId();
      setPurchaseDate(moment(props?.purchaseDate).format("YYYY-MM-DD"));
      props.onHide();
    }
  }

  return (
    <Modal
      size="md"
      centered
      show={props.show}
      //   onHide={props.onHide}
      dialogClassName="BuyPackage-modal"
    >
      {" "}
      <ModalBody>
        <div className="text-center">
          <img src={logo} alt="" height="30" />
          <h6 className="text-center" style={{ marginTop: "10px" }}>
            Buy Package
          </h6>
          <h6 className="text-center text-muted">
            Please select a package to buy.
          </h6>
        </div>
        <div>
          <div className="form-floating">
            <select
              className={`form-select`}
              id="servicePackage"
              aria-label="servicePackage"
              as="select"
              name="servicePackage"
              value={preDefinedPackageId}
              onChange={(e) => {
                setPreDefinedPackageId(+e.target.value);
              }}
              // disabled={!isConsumePackage}
            >
              <option value="">Select Package</option>
              {props?.preDefinedPackageList &&
                props?.preDefinedPackageList
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
            </select>
            <label htmlFor="servicePackage">
              <span>Select Package</span>
            </label>
          </div>
          <div>
            <div className="form-floating mt-3">
              <input
                type="date"
                className="form-control"
                id="purchaseDate"
                value={purchaseDate}
                onChange={(e) => setPurchaseDate(e.target.value)}
              />
              <label htmlFor="purchaseDate">
                <span>Select Package Start Date</span>
              </label>
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          disabled={!preDefinedPackageId}
          type="submit"
          buttonTitle={"Buy Package"}
          onClick={() => handleSubmit()}
        />
        <Button
          className="secondary outline"
          type="reset"
          onClick={() => {
            setPreDefinedPackageId();
            setPurchaseDate(moment(props?.purchaseDate).format("YYYY-MM-DD"));
            props.onHide();
          }}
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}
